import _ from 'lodash';
import AccessMode from './AccessMode';
import ActionCustomCommandType from './ActionCustomCommandType';
import ActionInstanceStatus from './ActionInstanceStatus';
import ActionIterationDataSource from './ActionIterationDataSource';
import ActionIterationStringDataSource from './ActionIterationStringDataSource';
import ActionOverdueOperation from './ActionOverdueOperation';
import ActionScheduledExecutionType from './ActionScheduledExecutionType';
import ActionType from './ActionType';
import ActionTypeString from './ActionTypeString';
import ActionUserInstanceUserOperationType from './ActionUserInstanceUserOperationType';
import ActionUserInstanceUserOperationTypeStatus from './ActionUserInstanceUserOperationTypeStatus';
import AIAgentVersionOperation from './AIAgentVersionOperation';
import AIAgentScheduleExecutionMode from './AIAgentScheduleExecutionMode';
import AIAgentScheduleInternalTaskRequestedOperation from './AIAgentScheduleInternalTaskRequestedOperation';
import AIAgentScheduleInternalTaskTriggerType from './AIAgentScheduleInternalTaskTriggerType';
import AIAgentScheduledInternalTaskOperationType from './AIAgentScheduledInternalTaskOperationType';
import AIAgentTriggerType from './AIAgentTriggerType';
import AIBillingMode from './AIBillingMode';
import AIBudgetEditMode from './AIBudgetEditMode';
import AIBudgetExceededBehavior from './AIBudgetExceededBehavior';
import AIBillingConsumptionLedgerKind from './AIBillingConsumptionLedgerKind';
import AIBudgetPeriodStatus from './AIBudgetPeriodStatus';
import AIVectorFileSyncStatus from './AIVectorFileSyncStatus';
import BillingCollectionMode from './BillingCollectionMode';
import BillingCycleType from './BillingCycleType';
import BillingPaymentMethodType from './BillingPaymentMethodType';
import BillingPaymentProviderType from './BillingPaymentProviderType';
import BillingPaymentSessionStatus from './BillingPaymentSessionStatus';
import BillingSubscriptionStatus from './BillingSubscriptionStatus';
import AICreditGrantType from './AICreditGrantType';
import AIConsumptionBillingMetric from './AIConsumptionBillingMetric';
import AIConsumptionSource from './AIConsumptionSource';
import AIProvider from './AIProvider';
import Currency from './Currency';
import ApiCallParameterCodification from './ApiCallParameterCodification';
import ApiParameterPosition from './ApiParameterPosition';
import ApiSendParameterPosition from './ApiSendParameterPosition';
import AppAuthMode from './AppAuthMode';
import ApplicationPage from './ApplicationPage';
import ApplicationResponseStatus from './ApplicationResponseStatus';
import AttachmentFileTypeClassification from './AttachmentFileTypeClassification';
import AttachmentFileTypeClassificationStatus from './AttachmentFileTypeClassificationStatus';
import AttachmentInstanceTypeStatus from './AttachmentInstanceTypeStatus';
import AttachmentMappingValueSource from './AttachmentMappingValueSource';
import AuthorizationType from './AuthorizationType';
import AutomyAIHandlerType from './AutomyAIHandlerType';
import BuilderElementType from './BuilderElementType';

import BulkActionType from './BulkActionType';
import BulkRequestFailureKind from './BulkRequestFailureKind';
import BulkRequestRetryDisposition from './BulkRequestRetryDisposition';
import BulkRequestTaskStatus from './BulkRequestTaskStatus';

import CompanyAccessPolicyDecision from './CompanyAccessPolicyDecision';
import CompanyAccessPolicyDefaultDecision from './CompanyAccessPolicyDefaultDecision';
import CompanyAccessPolicyEffect from './CompanyAccessPolicyEffect';
import CompanyAccessPolicyEvaluationMode from './CompanyAccessPolicyEvaluationMode';
import CompanyAccessPolicyRuleType from './CompanyAccessPolicyRuleType';
import ComparisonOperator from './ComparisonOperator';
import ConditionalValueSource from './ConditionalValueSource';
import ConfigurationEntityInternalTaskOperationType from './ConfigurationEntityInternalTaskOperationType';
import ConnectionAzureGraphCredentialType from './ConnectionAzureGraphCredentialType';
import ConnectionAzureGraphOperation from './ConnectionAzureGraphOperation';
import ConnectionGoogleCredentialType from './ConnectionGoogleCredentialType';
import ConnectionGoogleOperation from './ConnectionGoogleOperation';
import ConnectionType from './ConnectionType';
import CustomListCommandStringType from './CustomListCommandStringType';
import CustomListCommandType from './CustomListCommandType';
import CustomListDataOrigin from './CustomListDataOrigin';
import CustomListFieldStringType from './CustomListFieldStringType';
import CustomListFieldType from './CustomListFieldType';
import CustomListInternalTaskOperationType from './CustomListInternalTaskOperationType';
import CustomListPreFilterType from './CustomListPreFilterType';
import CustomListStringType from './CustomListStringType';
import CustomListType from './CustomListType';

import DatabaseType from './DatabaseType';
import DayOfWeek from './DayOfWeek';
import DelegatedTaskStatus from './DelegatedTaskStatus';
import DelegationStatus from './DelegationStatus';
import DelegationType from './DelegationType';
import DeliveryProvider from './DeliveryProvider';
import DigitalSignaturePosition from './DigitalSignaturePosition';
import DocumentSource from './DocumentSource';
import DynamicEntityInternalTaskOperationType from './DynamicEntityInternalTaskOperationType';
import DynamicEntityOperation from './DynamicEntityOperation';
import DynamicEntityOperationSearchResultAllocationMode from './DynamicEntityOperationSearchResultAllocationMode';
import DynamicEntityOperationSearchResultGroupingMode from './DynamicEntityOperationSearchResultGroupingMode';
import DynamicEntityStringOperation from './DynamicEntityStringOperation';
import DynamicEntityVersionOperation from './DynamicEntityVersionOperation';

import EmailMessageType from './EmailMessageType';
import EmailTemplateType from './EmailTemplateType';
import EntityQueryOperationType from './EntityQueryOperationType';
import EntityQuerySourceOperationType from './EntityQuerySourceOperationType';
import EnvironmentClassification from './EnvironmentClassification';
import ExportFormInstanceDataSourceFilter from './ExportFormInstanceDataSourceFilter';
import ExternalUserValueSource from './ExternalUserValueSource';

import FileType from './FileType';
import FilterDateRange from './FilterDateRange';
import FormFieldBehavior from './FormFieldBehavior';
import FormFieldColumnWidth from './FormFieldColumnWidth';
import FormFieldStringType from './FormFieldStringType';
import FormFieldType from './FormFieldType';
import FormPublicStyleTemplateType from './FormPublicStyleTemplateType';
import FormStyleTemplate from './FormStyleTemplate';
import FormTableCommand from './FormTableCommand';
import FormTableCommandBehavior from './FormTableCommandBehavior';
import FormTableMode from './FormTableMode';
import FtpAuthenticationMode from './FtpAuthenticationMode';
import FtpFileTransferType from './FtpFileTransferType';

import GoogleIntegrationOperationType from './GoogleIntegrationOperationType';
import GoogleIntegrationServiceType from './GoogleIntegrationServiceType';
import HttpMethod from './HttpMethod';
import HttpUserAgentPlatformType from './HttpUserAgentPlatformType';
import InternalFieldType from './InternalFieldType';
import InternalOperationEntity from './InternalOperationEntity';
import InternalOperationType from './InternalOperationType';
import InternalTaskStatus from './InternalTaskStatus';
import ItemsAffected from './ItemsAffected';
import JsonDataCreatorResourceType from './JsonDataCreatorResourceType';
import LocaleType from './LocaleType';
import LogicalOperator from './LogicalOperator';

import MailEvent from './MailEvent';
import MailTrackingValidationMode from './MailTrackingValidationMode';
import MappingFormFieldValueDestination from './MappingFormFieldValueDestination';
import MappingValueDestination from './MappingValueDestination';
import MappingValueSource from './MappingValueSource';
import MathOperationType from './MathOperationType';
import McpLaunchMode from './McpLaunchMode';
import McpTransport from './McpTransport';
import MediaOwnerType from './MediaOwnerType';
import MfaRequirementPolicy from './MfaRequirementPolicy';
import MonthName from './MonthName';

import PageOrientation from './PageOrientation';
import PaperType from './PaperType';
import PlainTextFileFormat from './PlainTextFileFormat';
import PlanType from './PlanType';
import PortalMenuItemType from './PortalMenuItemType';
import ProcessConfigItemType from './ProcessConfigItemType';
import ProcessEngineInternalTaskOperationType from './ProcessEngineInternalTaskOperationType';
import ProcessEngineVersion from './ProcessEngineVersion';
import ProcessInstanceApprovalOrigin from './ProcessInstanceApprovalOrigin';
import ProcessInstanceApprovalOriginStatus from './ProcessInstanceApprovalOriginStatus';
import ProcessInstanceCreatorResourceType from './ProcessInstanceCreatorResourceType';
import ProcessInstanceRequestOrigin from './ProcessInstanceRequestOrigin';
import ProcessInstanceSignalRMessage from './ProcessInstanceSignalRMessage';
import ProcessInstanceStatus from './ProcessInstanceStatus';
import ProcessStartMode from './ProcessStartMode';
import ProgrammingLanguage from './ProgrammingLanguage';

import ReferenceSourceEntity from './ReferenceSourceEntity';
import ReferenceSourceItemType from './ReferenceSourceItemType';
import ReportExportFormat from './ReportExportFormat';
import ReportInternalTaskOperationType from './ReportInternalTaskOperationType';
import ReportPlatform from './ReportPlatform';
import ReportTokenType from './ReportTokenType';
import ReportType from './ReportType';
import RequestDetailCommandType from './RequestDetailCommandType';
import RequestsCommentsAccessMode from './RequestsCommentsAccessMode';
import RequestStatusType from './RequestStatusType';
import ResponseHttpStatusCode from './ResponseHttpStatusCode';
import RoleName from './RoleName';
import RpaAgentEffectiveStatus from './RpaAgentEffectiveStatus';
import RpaAgentPlatform from './RpaAgentPlatform';
import RpaAgentSessionEndReason from './RpaAgentSessionEndReason';
import RpaAgentSessionStatus from './RpaAgentSessionStatus';
import RpaAgentStatus from './RpaAgentStatus';
import RpaInstanceResponseStatus from './RpaInstanceResponseStatus';
import RpaInstanceSendStatus from './RpaInstanceSendStatus';
import RunCodeOperationStatus from './RunCodeOperationStatus';

import ServerType from './ServerType';
import SharePointOperation from './SharePointOperation';
import SignalRMessageType from './SignalRMessageType';
import SkillSourceProvider from './SkillSourceProvider';
import SmsDeliveryProvider from './SmsDeliveryProvider';

import SocketProcessInstanceMessageType from './SocketProcessInstanceMessageType';

import TableDefaultSortMode from './TableDefaultSortMode';
import TableRowPropertyValueDestination from './TableRowPropertyValueDestination';
import TaskCreatorType from './TaskCreatorType';
import TaskImportance from './TaskImportance';
import TaskListType from './TaskListType';
import TaskStatus from './TaskStatus';
import TaskType from './TaskType';
import TemplateGenerationFormat from './TemplateGenerationFormat';
import TextFormat from './TextFormat';
import TraceActor from './TraceActor';
import TraceOperation from './TraceOperation';
import TwoFactorProvider from './TwoFactorProvider';

import UserAccessLogOperationType from './UserAccessLogOperationType';
import UserAccessType from './UserAccessType';
import UserBusinessContext from './UserBusinessContext';
import UserCustomTaskListType from './UserCustomTaskListType';
import UserDisplayStringValue from './UserDisplayStringValue';
import UserDisplayValue from './UserDisplayValue';
import UserRole from './UserRole';
import VariableType from './VariableType';

import WaitChildRequestsChildrenFailureBehavior from './WaitChildRequestsChildrenFailureBehavior';
import WaitChildRequestsCompletionMode from './WaitChildRequestsCompletionMode';
import WaitChildRequestsItemFailureReason from './WaitChildRequestsItemFailureReason';
import WaitChildRequestsItemStatus from './WaitChildRequestsItemStatus';
import WaitChildRequestsNoChildrenBehavior from './WaitChildRequestsNoChildrenBehavior';
import WaitChildRequestsResultType from './WaitChildRequestsResultType';
import WaitChildRequestsScope from './WaitChildRequestsScope';
import WaitChildRequestsTimeoutBehavior from './WaitChildRequestsTimeoutBehavior';
import WebhookMappingValueDestination from './WebhookMappingValueDestination';
import WhiteLabelCustomDomainStatus from './WhiteLabelCustomDomainStatus';
import WhiteLabelSource from './WhiteLabelSource';
import ProcessInstanceNumberingPeriodKind from './ProcessInstanceNumberingPeriodKind';
import WhatsAppBusinessIntegrationOperationType from './WhatsAppBusinessIntegrationOperationType';
import WizardOrientation from './WizardOrientation';
import WizardStepStyle from './WizardStepStyle';

import ColumnOrderDirection from './ColumnOrderDirection';
import FrequencyUnit from './FrequencyUnit';
import GuardrailsUrlFilterAction from './GuardrailsUrlFilterAction';
import GuardrailsUrlFilterMode from './GuardrailsUrlFilterMode';
import OpenAIMessageToolType from './OpenAIMessageToolType';
import OpenAIOperationType from './OpenAIOperationType';
import OpenAIResponsesReasoningEffort from './OpenAIResponsesReasoningEffort';
import OpenAIResponsesReasoningSummary from './OpenAIResponsesReasoningSummary';
import OpenAIRunStatus from './OpenAIRunStatus';
import OperationResultStatus from './OperationResultStatus';
import PiiAction from './PiiAction';
import PiiEntityType from './PiiEntityType';
import ResponseGroupingType from './ResponseGroupingType';

// Chat
import ChatAIThinkingOperationType from './ChatAIThinkingOperationType';
import ChatAssignmentMode from './ChatAssignmentMode';
import ChatAttentionChannelType from './ChatAttentionChannelType';
import ChatControlMode from './ChatControlMode';
import ChatHandlerType from './ChatHandlerType';
import ChatMessageContentItemType from './ChatMessageContentItemType';
import ChatMessageStatus from './ChatMessageStatus';
import ChatMessageType from './ChatMessageType';
import ChatOwnerType from './ChatOwnerType';
import ChatThreadStatus from './ChatThreadStatus';
import ChatType from './ChatType';
import ChannelAgreementApprovalStatus from './ChannelAgreementApprovalStatus';
import ChannelAgreementBaseAmountType from './ChannelAgreementBaseAmountType';
import ChannelAgreementBeneficiaryType from './ChannelAgreementBeneficiaryType';
import ChannelAgreementCalculationType from './ChannelAgreementCalculationType';
import ChannelAgreementCommissionableEventType from './ChannelAgreementCommissionableEventType';
import ChannelAgreementOwnerType from './ChannelAgreementOwnerType';
import ChannelAgreementType from './ChannelAgreementType';
import AutomyPlanCategory from './AutomyPlanCategory';
import AutomyPlanKind from './AutomyPlanKind';
import AutomyPlanScope from './AutomyPlanScope';
import ChannelActorKind from './ChannelActorKind';
import ChannelBillingMode from './ChannelBillingMode';
import ChannelEntityStatus from './ChannelEntityStatus';
import DistributorPartnerAgreementMode from './DistributorPartnerAgreementMode';
import ChannelPayoutMode from './ChannelPayoutMode';
import CommissionBaseType from './CommissionBaseType';
import CommissionRevenueType from './CommissionRevenueType';
import CommissionSettlementScope from './CommissionSettlementScope';
import CustomerChannelSourceType from './CustomerChannelSourceType';
import ResellerBillingResponsibility from './ResellerBillingResponsibility';
import RuleFrequencyType from './RuleFrequencyType';
import FtpOperationType from './FtpOperationType';
import MessageStatus from './MessageStatus';
import NotificationPriority from './NotificationPriority';
import NotificationType from './NotificationType';
import SocketChannels from './SocketChannels';
import SocketMessageType from './SocketMessageType';
import TeamsConversationDestinationType from './TeamsConversationDestinationType';
import TeamsMessageFormat from './TeamsMessageFormat';
import LogicalOperatorString from './LogicalOperatorString';
import ConditionalValueSourceString from './ConditionalValueSourceString';
import OpenAIResponsesReasoningEffortString from './OpenAIResponsesReasoningEffortString';
import FrequencyUnitString from './FrequencyUnitString';
import ApiParameterPositionString from './ApiParameterPositionString';
import ApiCallParameterCodificationString from './ApiCallParameterCodificationString';
import WebhookMappingValueDestinationString from './WebhookMappingValueDestinationString';
import MappingValueDestinationString from './MappingValueDestinationString';
import MappingFormFieldValueDestinationString from './MappingFormFieldValueDestinationString';
import ParallelRejectionBehaviorString from './ParallelRejectionBehaviorString';
import OpenAIResponsesReasoningSummaryString from './OpenAIResponsesReasoningSummaryString';
import ItemsAffectedString from './ItemsAffectedString';
import OpenAIOperationTypeString from './OpenAIOperationTypeString';
import AutomyAIHandlerTypeString from './AutomyAIHandlerTypeString';
import InternalOperationTypeString from './InternalOperationTypeString';
import InternalOperationEntityString from './InternalOperationEntityString';
import GoogleIntegrationServiceTypeString from './GoogleIntegrationServiceTypeString';
import GoogleIntegrationOperationTypeString from './GoogleIntegrationOperationTypeString';
import SharePointOperationString from './SharePointOperationString';
import WhatsAppBusinessIntegrationOperationTypeString from './WhatsAppBusinessIntegrationOperationTypeString';
import ProgrammingLanguageString from './ProgrammingLanguageString';
import WaitChildRequestsScopeString from './WaitChildRequestsScopeString';
import WaitChildRequestsCompletionModeString from './WaitChildRequestsCompletionModeString';
import WaitChildRequestsTimeoutBehaviorString from './WaitChildRequestsTimeoutBehaviorString';
import WaitChildRequestsNoChildrenBehaviorString from './WaitChildRequestsNoChildrenBehaviorString';
import WaitChildRequestsChildrenFailureBehaviorString from './WaitChildRequestsChildrenFailureBehaviorString';

function toStrCase(key, strCase) {
  return {
    default: key,
    camel: _.camelCase(key),
    snake: _.snakeCase(key),
    kebab: _.kebabCase(key),
    title: _.chain(key).kebabCase().split('-').startCase().value(),
  }[strCase];
}

function reversePair(key, options) {
  const keyName = toStrCase(key, options.case);
  return options.prefix ? `${options.prefix}.${keyName}` : keyName;
}

export function reverseEnumerator(obj, options = { case: 'default', prefix: null }) {
  return _.toPairs(obj).reduce((lhs, [key, num]) => {
    return {
      ...lhs,
      [num]: reversePair(key, options),
    };
  }, {});
}

export function transformEnumeratorKeys(obj, options = { case: 'default' }) {
  return _.toPairs(obj).reduce((lhs, [key, num]) => {
    return {
      ...lhs,
      [toStrCase(key, options.case)]: num,
    };
  }, {});
}

const CoreEnums = (function () {
  return {
    ActionCustomCommandType,
    ActionInstanceStatus,
    ActionScheduledExecutionType,
    ActionType,
    ActionTypeString,
    ActionUserInstanceUserOperationType,
    ActionUserInstanceUserOperationTypeStatus,
    AttachmentFileTypeClassification,
    AttachmentFileTypeClassificationStatus,
    AttachmentInstanceTypeStatus,
    AuthorizationType,
    ApiSendParameterPosition,
    ApiParameterPosition,
    ApiCallParameterCodification,
    AttachmentMappingValueSource,
    ActionIterationDataSource,
    ActionIterationStringDataSource,
    ActionOverdueOperation,
    ApplicationPage,
    ApplicationResponseStatus,
    AppAuthMode,
    AutomyAIHandlerType,
    AccessMode,
    AIAgentVersionOperation,
    AIAgentScheduleExecutionMode,
    AIAgentScheduleInternalTaskRequestedOperation,
    AIAgentScheduleInternalTaskTriggerType,
    AIAgentScheduledInternalTaskOperationType,
    AIAgentTriggerType,
    AIBillingMode,
    AIBudgetEditMode,
    AIBudgetExceededBehavior,
    AIBillingConsumptionLedgerKind,
    AIBudgetPeriodStatus,
    AIVectorFileSyncStatus,
    BillingCollectionMode,
    BillingCycleType,
    BillingPaymentMethodType,
    BillingPaymentProviderType,
    BillingPaymentSessionStatus,
    BillingSubscriptionStatus,
    AICreditGrantType,
    AIProvider,
    AIConsumptionBillingMetric,
    AIConsumptionSource,
    Currency,

    BuilderElementType,
    BulkActionType,
    BulkRequestFailureKind,
    BulkRequestRetryDisposition,
    BulkRequestTaskStatus,

    ComparisonOperator,
    CompanyAccessPolicyDecision,
    CompanyAccessPolicyDefaultDecision,
    CompanyAccessPolicyEffect,
    CompanyAccessPolicyEvaluationMode,
    CompanyAccessPolicyRuleType,
    CustomListCommandStringType,
    CustomListCommandType,
    CustomListFieldType,
    CustomListFieldStringType,
    CustomListInternalTaskOperationType,
    CustomListPreFilterType,
    CustomListType,
    CustomListStringType,
    CustomListDataOrigin,
    ConditionalValueSource,
    ConfigurationEntityInternalTaskOperationType,
    ConnectionAzureGraphCredentialType,
    ConnectionAzureGraphOperation,
    ConnectionGoogleCredentialType,
    ConnectionGoogleOperation,
    ConnectionType,
    DatabaseType,
    DayOfWeek,
    DelegationStatus,
    DynamicEntityInternalTaskOperationType,
    DynamicEntityOperation,
    DynamicEntityOperationSearchResultAllocationMode,
    DynamicEntityOperationSearchResultGroupingMode,
    DynamicEntityStringOperation,
    DynamicEntityVersionOperation,
    DigitalSignaturePosition,
    DelegationType,
    DelegatedTaskStatus,
    DocumentSource,
    DeliveryProvider,

    EmailTemplateType,
    EnvironmentClassification,
    EntityQuerySourceOperationType,
    EmailMessageType,
    EntityQueryOperationType,
    ExportFormInstanceDataSourceFilter,
    ExternalUserValueSource,

    FileType,
    FilterDateRange,
    FormFieldBehavior,
    FormFieldColumnWidth,
    FormFieldType,
    FormFieldStringType,
    FormPublicStyleTemplateType,
    FormStyleTemplate,
    FtpOperationType,
    FormTableCommand,
    FormTableCommandBehavior,
    FormTableMode,
    FtpFileTransferType,
    FtpAuthenticationMode,

    GoogleIntegrationOperationType,
    GoogleIntegrationServiceType,
    HttpMethod,
    HttpUserAgentPlatformType,
    InternalFieldType,
    InternalOperationEntity,
    InternalOperationType,
    InternalTaskStatus,
    ItemsAffected,
    JsonDataCreatorResourceType,
    LogicalOperator,
    LocaleType,

    MathOperationType,
    MediaOwnerType,
    McpLaunchMode,
    McpTransport,
    MfaRequirementPolicy,
    MailEvent,
    MailTrackingValidationMode,
    MappingFormFieldValueDestination,
    MappingValueSource,
    MappingValueDestination,
    TableRowPropertyValueDestination,
    MonthName,

    PageOrientation,
    PaperType,
    ProcessConfigItemType,
    ProcessEngineInternalTaskOperationType,
    ProcessInstanceApprovalOrigin,
    ProcessInstanceApprovalOriginStatus,
    ProcessInstanceCreatorResourceType,
    ProcessInstanceRequestOrigin,
    ProcessInstanceStatus,
    ProcessStartMode,
    ProcessInstanceSignalRMessage,
    PlanType,
    PlainTextFileFormat,
    PortalMenuItemType,
    ProcessEngineVersion,
    ProgrammingLanguage,

    ReportExportFormat,
    ReportInternalTaskOperationType,
    ReportTokenType,
    ReportType,
    ReportPlatform,
    RequestDetailCommandType,
    RequestStatusType,
    RequestsCommentsAccessMode,
    ResponseHttpStatusCode,
    RoleName,
    RpaAgentEffectiveStatus,
    RpaAgentPlatform,
    RpaAgentSessionEndReason,
    RpaAgentSessionStatus,
    RpaAgentStatus,
    RpaInstanceResponseStatus,
    RpaInstanceSendStatus,
    RunCodeOperationStatus,
    ReferenceSourceItemType,
    ReferenceSourceEntity,

    SharePointOperation,
    SignalRMessageType,
    SkillSourceProvider,
    SmsDeliveryProvider,
    SocketProcessInstanceMessageType,
    ServerType,

    TraceActor,
    TwoFactorProvider,
    TemplateGenerationFormat,
    TaskType,
    TaskListType,
    TaskStatus,
    TaskImportance,
    TaskCreatorType,
    TraceOperation,
    TextFormat,
    TableDefaultSortMode,

    UserAccessType,
    UserAccessLogOperationType,
    UserDisplayStringValue,
    UserDisplayValue,
    UserBusinessContext,
    UserRole,
    UserCustomTaskListType,
    VariableType,

    WaitChildRequestsChildrenFailureBehavior,
    WaitChildRequestsCompletionMode,
    WaitChildRequestsItemFailureReason,
    WaitChildRequestsItemStatus,
    WaitChildRequestsNoChildrenBehavior,
    WaitChildRequestsResultType,
    WaitChildRequestsScope,
    WaitChildRequestsTimeoutBehavior,

    WhatsAppBusinessIntegrationOperationType,
    WebhookMappingValueDestination,
    WhiteLabelCustomDomainStatus,
    WhiteLabelSource,
    ProcessInstanceNumberingPeriodKind,
    WizardOrientation,
    WizardStepStyle,
    FrequencyUnit,
    OpenAIOperationType,
    OpenAIRunStatus,
    OpenAIResponsesReasoningEffort,
    OpenAIResponsesReasoningSummary,
    OpenAIMessageToolType,
    PiiEntityType,
    PiiAction,
    GuardrailsUrlFilterAction,
    GuardrailsUrlFilterMode,
    OperationResultStatus,

    ResponseGroupingType,
    ColumnOrderDirection,

    // channel commercial
    ChannelAgreementApprovalStatus,
    ChannelAgreementBaseAmountType,
    ChannelAgreementBeneficiaryType,
    ChannelAgreementCalculationType,
    ChannelAgreementCommissionableEventType,
    ChannelAgreementOwnerType,
    ChannelAgreementType,
    AutomyPlanCategory,
    AutomyPlanKind,
    AutomyPlanScope,
    ChannelActorKind,
    ChannelBillingMode,
    ChannelEntityStatus,
    DistributorPartnerAgreementMode,
    ChannelPayoutMode,
    CommissionBaseType,
    CommissionRevenueType,
    CommissionSettlementScope,
    CustomerChannelSourceType,
    ResellerBillingResponsibility,
    RuleFrequencyType,

    // chat
    ChatAssignmentMode,
    ChatType,
    ChatOwnerType,
    ChatThreadStatus,
    ChatMessageType,
    ChatMessageStatus,
    ChatAIThinkingOperationType,
    ChatMessageContentItemType,
    MessageStatus,
    TeamsConversationDestinationType,
    TeamsMessageFormat,
    LogicalOperatorString,
    ConditionalValueSourceString,
    OpenAIResponsesReasoningEffortString,
    FrequencyUnitString,
    ApiParameterPositionString,
    ApiCallParameterCodificationString,
    WebhookMappingValueDestinationString,
    MappingValueDestinationString,
    MappingFormFieldValueDestinationString,
    ParallelRejectionBehaviorString,
    OpenAIResponsesReasoningSummaryString,
    ItemsAffectedString,
    OpenAIOperationTypeString,
    AutomyAIHandlerTypeString,
    InternalOperationTypeString,
    InternalOperationEntityString,
    GoogleIntegrationServiceTypeString,
    GoogleIntegrationOperationTypeString,
    SharePointOperationString,
    WhatsAppBusinessIntegrationOperationTypeString,
    ProgrammingLanguageString,
    WaitChildRequestsScopeString,
    WaitChildRequestsCompletionModeString,
    WaitChildRequestsTimeoutBehaviorString,
    WaitChildRequestsNoChildrenBehaviorString,
    WaitChildRequestsChildrenFailureBehaviorString,
    ChatHandlerType,
    ChatControlMode,
    ChatAttentionChannelType,
    SocketMessageType,
    SocketChannels,
    NotificationPriority,
    NotificationType,
  };
})();

export default CoreEnums;
